<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <p-accordion id="accordion" [multiple]="false" (onOpen)="abrirAcordeon($event)">
    <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIA' | translate }}" [selected]="tabSeleccionado === 'CAM'">
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <h2 class="titulo-pagina">{{'CAMPANIA.LBL_INFORGENERAL' | translate}}</h2>
        </div>
      </div>
      <div class="grid">
        <div class="col-12">
            <div class="grid">
              <label class="lg:col-5 col-6 md:col-4 control-label">{{ 'CAMPANIA.LBL_CODIGO' | translate }}:</label>
              <label class="lg:col-1 col-6 md:col-8 "  *ngIf="campania"><strong>{{campania.codigo | uppercase }}</strong></label>
              <label class="lg:col-1 col-6 md:col-4 control-label">{{ 'CAMPANIA.LBL_NOMBRE' | translate }}:</label>
              <label class="lg:col-5 col-6 md:col-8"  *ngIf="campania"><strong>{{campania.nombre}}</strong></label>
            </div>
            <div class="grid">
              <label class="lg:col-5 col-6 md:col-4 control-label">{{ 'CAMPANIA.LBL_FECHAINICIO' | translate }}:</label>
              <label class="lg:col-1 col-6 md:col-8"  *ngIf="campania"><strong>{{ campania.fechaInicio }}</strong></label>
              <label class="lg:col-1 col-6 md:col-4 control-label">{{ 'CAMPANIA.LBL_FECHAFIN' | translate }}:</label>
              <label class="lg:col-5 col-6 md:col-8"  *ngIf="campania"><strong>{{campania.fechaFin}}</strong></label>
            </div>
        </div>
      </div>

      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar()"></button>
        </div>
      </div>

    </p-accordionTab>

    <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIACICLO' | translate }}" [selected]="tabSeleccionado === 'CAMC'" [disabled]="!campania">

      <app-campanias-dcto-ciclos-detalle [campania]="campania" *ngIf="campania && campania.idCampania">
      </app-campanias-dcto-ciclos-detalle>

    </p-accordionTab>
    <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIAMONTO' | translate }}" [selected]="tabSeleccionado === 'CAMM'" [disabled]="!campania">
      <app-campanias-dcto-montos-detalle [campania]="campania" *ngIf="campania && campania.idCampania">
      </app-campanias-dcto-montos-detalle>
    </p-accordionTab>

    <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIADESTINOCREDITO' | translate }}" [selected]="tabSeleccionado === 'CIC'"
                    [disabled]="!campania">
      <app-campania-descuento-destino-detalle [campania]="campania" *ngIf="campania && campania.idCampania">
      </app-campania-descuento-destino-detalle>
    </p-accordionTab>

    <p-accordionTab header="{{ 'CAMPANIA.LBL_CAMPANIADIAMORA' | translate }}" [selected]="tabSeleccionado === 'CIC'" [disabled]="!campania">
      <app-campania-descuento-mora-detalle [campania]="campania" *ngIf="campania && campania.idCampania">
      </app-campania-descuento-mora-detalle>
    </p-accordionTab>
  </p-accordion>

</div>

